var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3978 10.6979C32.1787 9.99055 32.1787 8.84187 31.3978 8.13456L23.4015 0.89169C22.6206 0.184378 21.3525 0.184378 20.5716 0.89169C19.7907 1.599 19.7907 2.74768 20.5716 3.45499L25.157 7.60832H1.99906C0.893331 7.60832 0 8.41748 0 9.41904C0 10.4206 0.893331 11.2298 1.99906 11.2298H25.157L20.5716 15.3831C19.7907 16.0904 19.7907 17.2391 20.5716 17.9464C21.3525 18.6537 22.6206 18.6537 23.4015 17.9464L31.3978 10.7035V10.6979Z",
    fill: "#FA6900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ec42be01842f2d33e8cc600b78677ceb.svg";
export { ForwardRef as ReactComponent };